export function stringToPatternObject(patternString) {
  const regex = /\[([-?\d\s,]+)\]/g;
  const matches = patternString.matchAll(regex);
  const rows = Array.from(matches, match => {
    const row = match[1].split(',').map(cell => ({
      proportion: parseInt(cell.trim(), 10)
    }));
    return {
      cells: row
    };
  });
  return {
    rows
  };
}
export function patternObjectToPatternArray(objModel) {
  return objModel.rows.map(row => row.cells.map(cell => cell.proportion));
}
export function patternArrayToPatternObject(arrayModel) {
  return {
    rows: arrayModel.map(row => ({
      cells: row.map(proportion => ({
        proportion
      }))
    }))
  };
}
export function patternArrayToString(patternArray) {
  return JSON.stringify(patternArray);
}
export function makePatternArrayPositive(arr) {
  return arr.map(row => row.map(item => Math.abs(item)));
}
//# sourceMappingURL=customGridTypesConverters.js.map